var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14713 11.375C6.14568 10.3373 6.34964 9.30949 6.74725 8.35094C7.14486 7.39239 7.72826 6.52202 8.46382 5.78999C9.19938 5.05797 10.0725 4.47877 11.033 4.08577C11.9934 3.69278 13.0222 3.49377 14.0599 3.50021C18.39 3.5324 21.8536 7.13161 21.8536 11.4739V12.25C21.8536 16.1673 22.6732 18.4405 23.395 19.6829C23.4728 19.8157 23.5141 19.9666 23.515 20.1204C23.5158 20.2743 23.476 20.4256 23.3997 20.5592C23.3234 20.6928 23.2131 20.8039 23.0802 20.8813C22.9472 20.9586 22.7962 20.9996 22.6423 21H5.35751C5.20364 20.9996 5.0526 20.9586 4.91962 20.8812C4.78664 20.8038 4.67643 20.6927 4.6001 20.5591C4.52377 20.4255 4.48403 20.2741 4.48488 20.1203C4.48573 19.9664 4.52714 19.8155 4.60494 19.6827C5.32717 18.4403 6.14713 16.1671 6.14713 12.25L6.14713 11.375Z",
    stroke: "#413A44",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21V21.875C10.5 22.8033 10.8687 23.6935 11.5251 24.3499C12.1815 25.0063 13.0717 25.375 14 25.375C14.9283 25.375 15.8185 25.0063 16.4749 24.3499C17.1313 23.6935 17.5 22.8033 17.5 21.875V21",
    stroke: "#413A44",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9eeebe5dc80395315f2dd097523d25da.svg";
export { ForwardRef as ReactComponent };